import jwtService from "@service/jwt-service";
import CustomStore from "devextreme/data/custom_store";
import { CommonUtil } from "@utils/CommonUtil";
import { CommonConst } from "@constants/common-const";
import { commonNotify } from "@utils/common";

const axios = jwtService.axiosIns;

// 설계 유형별 상세 시설 조회
async function _getCounselDesignModel(type: string) {
  return await axios.get(`/hcosts/designs/models/facility-type/${type}`);
}
// 견적상담 모델 목록 조회
async function _getCounselModelDataSource(params: string) {
  return await axios.get(`/admin/hcosts/designs/models?${params}`);
}

// 견적상담 모델 조희
export async function _getCounselModel(modelKey: string) {
  return await axios.get(`/admin/hcosts/designs/models/${modelKey}`);
}

// 견적상담 모델 등록
async function createCounselModel(...args: any[]) {
  return await axios.post("/admin/hcosts/designs/models", ...args);
}

// 견적상담 모델 수정
async function updateCounselModel(id: number, ...args: any[]) {
  return await axios.put(`/admin/hcosts/designs/models/${id}`, ...args);
}

/**
 * 설계 유형별 상세 시설 조회하기
 * @param type
 */
export async function getCounselDesignModel(type: string) {
  try {
    // 조회
    const { data } = await _getCounselDesignModel(type);
    return data;
  } catch (e) {
    commonNotify(CommonConst.errorGet, "error");
    throw e;
  } finally {
  }
}

/**
 * 견적상담 모델 목록 가져오기(DxDataGrid용)
 */
export function getCounselModelDataSource() {
  return new CustomStore({
    key: "id",
    onLoading() {},
    onLoaded() {},
    load: async loadOptions => {
      // 파라미터 생성
      const params = CommonUtil.makeDxDataGridParams(loadOptions);
      try {
        const { data } = await _getCounselModelDataSource(params);
        return data;
      } catch (e) {
        throw new Error("Data Loading Error");
      }
    },
  });
}

/**
 * 견적상담 모델 조회하기
 * @param modelKey
 */
export async function getCounselModel(modelKey: string) {
  try {
    // 조회
    const { data } = await _getCounselModel(modelKey);

    return data;
  } catch (e) {
    commonNotify(CommonConst.errorGet, "error");
    throw e;
  } finally {
  }
}

/**
 * 견적상담 모델 저장하기
 */
export async function saveCounselModel(modifyType: string, counselModel: CounselModel) {
  // 통신
  try {
    if (modifyType === CommonConst.MODIFY_TYPE_CREATE) {
      await createCounselModel(counselModel, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } else if (modifyType === CommonConst.MODIFY_TYPE_UPDATE) {
      await updateCounselModel(counselModel.id, counselModel, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    }
    commonNotify(CommonConst.completeSave);
  } catch (e) {
    commonNotify(CommonConst.errorSave, "error");
    throw e;
  } finally {
  }
}
